import * as React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {useSelector} from 'react-redux';

import useModalById from '~/customHooks/useModalById';
import {MODAL_LOCATION_DISABLED_FLASH} from '~/rootStore/modals/modalsIds';
import {navigatorPermissionsSelector} from '~/modules/App/store/selectors';
import {NavigatorPermissions} from '~/constants/navigator';
import {requestGeolocation} from '~/modules/App/store/geoActions';

import ModalBaseContent from '../ModalBaseContent';
import ModalLocationBase from '../ModalLocationBase';
import Logo from '../Logo';

const useStyles = makeStyles(() => ({
  illustration: {
    width: 41,
    height: 41,
  },
}));

const ModalLocationDisabledFlash: React.FC = () => {
  const s = useStyles();
  const navigatorPermissions = useSelector(navigatorPermissionsSelector);

  const modalLocationDisabledFlash = useModalById(MODAL_LOCATION_DISABLED_FLASH);

  const handleCloseModal = async () => {
    if (navigatorPermissions.geolocation === NavigatorPermissions.BLOCK) {
      await requestGeolocation();
    }
    modalLocationDisabledFlash.close();
  };

  return (
    <ModalLocationBase
      open={modalLocationDisabledFlash.isOpen}
      onClose={handleCloseModal}
      okBtnText="Try again"
    >
      <ModalBaseContent
        p={2}
        image={<Logo className={s.illustration} />}
        title="Unable to determine your location"
        description="Give Bendr permission to use your location to start chatting & calling for free today."
      />
    </ModalLocationBase>
  );
};

export default ModalLocationDisabledFlash;
